import { render, staticRenderFns } from "./EmployeeRegistryFile.vue?vue&type=template&id=45dff678&"
import script from "./EmployeeRegistryFile.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports